import { analyticsApiClient } from "./services/analytics";

const analytics = analyticsApiClient('store-events');

export default analytics;
